import React, { Component } from 'react'
import Rating from 'react-rating'
import TextAreaInput from '../../inputs/TextAreaInput'
import ReportModal from '../../modals/ReportModal'
import Responsive from '../../Responsive'
import SidebarView from '../../SidebarView'
// import Slider from '../../slider/Slider'
import SliderSingle from '../../slider/SliderSingle'




export default class Reviews extends Component {
    state = {
        info: [
            { title: "Offered by", des: "zoom.us" },
            { title: "Version", des: "1.8.13" },
            { title: "Updated", des: "March 6, 2023" },
            { title: "Size", des: "235KiB" },
            { title: "Languages", des: "English, French, Spanish" },
            { title: "Developer", des: "This developer has identified itself as a trader per the definition from the European Union." },

        ],

        reviews: [
            { img: "/images/p2.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p3.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p4.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p5.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p6.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p7.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
            { img: "/images/p8.png", name: "Sara Mohseni", date: "Feb 3 2022", review: "its great, i used it for coupons mostly, so far I havent found anyone that works but still useful" },
        ],

    }

    openReply = () => {
        this.Reply.openSidebar()
    }

    openRewiew = () => {
        this.writeReview.openSidebar()
    }

    render() {
        return (
            <div className='w-100'>
                <div className='d-flex' style={{ backgroundColor: "#fff" }}>
                    <Responsive width={this.props.width} media={this.props.col ?? { xs: "12", }}>
                        <div className='p-4'>
                            <div className='flexcb'>
                                <p className='font-size-20' style={{ color: "#444" }}>User Reviews</p>
                                <button className='flexc' onClick={() => this.openRewiew()}>
                                    <img src='/assets/icons/textbox.svg' />
                                    <p className='mld-3' style={{ color: "#555" }}>Write a review</p>
                                </button>
                            </div>
                            <div className='mt-3'>
                                {this.state.reviews.map((prop, index) => {
                                    return (
                                        <div className='py-5' style={{ borderBottom: "1px solid #eee" }}>
                                            <div className='flexc'>
                                                <img className='br-10' width={60} src={prop.img} />
                                                <div className='mld-4 w-100'>
                                                    <div className='flexcb w-100'>
                                                        <div className='flexc'>
                                                            <p>{prop.name}</p>
                                                            <p className='px-3 font-size-14' style={{ color: "#777" }}>{prop.date}</p>
                                                        </div>
                                                        <div className='flexc px-3'>
                                                            <img width={15} src='/assets/icons/star.svg' />
                                                            <img width={15} src='/assets/icons/star.svg' />
                                                            <img width={15} src='/assets/icons/star.svg' />
                                                            <img width={15} src='/assets/icons/star.svg' />
                                                            <img width={15} src='/assets/icons/star-empty.svg' />
                                                            <p className='mld-3 font-size-12' style={{ color: "#777" }}>(2,034)</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <p className='font-size-12' style={{ color: "#666" }}>{prop.review}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flexcb mt-3'>
                                                <div className='flexc'>
                                                    <p className='mrd-5' style={{ color: "#444" }}>Was this review helpful?</p>
                                                    <button className='px-3 mx-2 br-5 green-box-fs'>
                                                        <p>Yes</p>
                                                    </button>
                                                    {/* <button className='px-3 mx-2 br-5 red-box-fs'>
                                                        <p>No</p>
                                                    </button> */}
                                                </div>
                                                <div className='mld-4 flexc'>
                                                    <button className='px-3 flexcc' onClick={() => this.openReply()}>
                                                        <img width={28} src='/assets/icons/reply-blue.svg' />
                                                    </button>
                                                    <button className='px-3 flexcc' style={{ borderLeft: "1px solid #666" }} onClick={() => this.reportModal.modal.showModal()}>
                                                        <img width={20} src='/assets/icons/report.svg' />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </Responsive>
                </div>
                <SidebarView hight={"100%"} width={this.props.width} ref={el => this.Reply = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "40%", md: '40%', lg: "30%", xl: "30%" }}>
                    <div className='p-4 w-100 h-100 scroll-no-scrollbar'>
                        <div className='flexc'>
                            <img className='br-10 mrd-3' width={50} src='/images/p3.png' />
                            <p className='font-size-16 weight-600' style={{ color: "#333" }}>Reply to Sara Mohseni</p>
                        </div>
                        <div className='mt-3 p-3 br-10' style={{ backgroundColor: "#f6f6f6" }}>
                            <p className='font-size-12' style={{ color: "#555" }}>its great, i used it for coupons mostly, so far I havent found anyone that works but still useful</p>
                        </div>
                        <div className='mt-3'>
                            <TextAreaInput changeValue={this.changeDescription} data={this.state.permission?.description} header={{ key: 'description', information: { rows: 3, placeholder: '{{lang}}description', } }} />
                        </div>
                        <div className="w-100 d-flex mt-2" style={{ justifyContent: "flex-end" }}>
                            <button className="px-3 py-2 br-10" style={{ backgroundColor: "#0085FF", }}>
                                <p className="white font-size-14 weight-500">Submit</p>
                            </button>
                        </div>
                    </div>
                </SidebarView>
                <SidebarView hight={"100%"} width={this.props.width} ref={el => this.writeReview = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "40%", md: '40%', lg: "30%", xl: "30%" }}>
                    <div className='p-4 w-100 h-100 scroll-no-scrollbar'>
                        <div className='flexc'>
                            <img className='br-10 mrd-3' width={50} src='/images/p3.png' />
                            <p className='font-size-16 weight-600' style={{ color: "#333" }}>Sara Mohseni</p>
                        </div>
                        <div className='flexc mt-3'>
                            <Rating
                                emptySymbol={<img src="assets/icons/star-empty.svg" className="" />}
                                fullSymbol={<img src="assets/icons/star.svg" className="" />}
                            />
                            <p className='mld-3' style={{ color: "#777" }}>2,034</p>
                        </div>
                        <div className='mt-3'>
                            <TextAreaInput changeValue={this.changeDescription} data={this.state.permission?.description} header={{ key: 'description', information: { rows: 3, placeholder: '{{lang}}description', } }} />
                        </div>
                        <div className="w-100 d-flex mt-2" style={{ justifyContent: "flex-end" }}>
                            <button className="px-3 py-2 br-10" style={{ backgroundColor: "#0085FF", }}>
                                <p className="white font-size-14 weight-500">Submit</p>
                            </button>
                        </div>
                    </div>
                </SidebarView>
                <ReportModal width={this.props.width} closeModal={() => this.reportModal.modal.hideModal()} ref={el => this.reportModal = el} data={this.state?.course} />
            </div>
        )
    }
}
